export default __webpack_public_path__ + "static/media/blog2.a5b0fe21.jpg";